<template>
  <div class="headman-manage">
    <div class="form-container">
      <div class="flex">
        <span class="title">仓库名称：</span>
        <el-select class="white" clearable v-model="form.warehouseId" placeholder="请选择">
          <el-option
            v-for="item in warehouseList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <span class="title">组长姓名：</span>
        <el-input v-model="form.username" placeholder="请输入"></el-input>
        <el-button class="btn-blue" icon="el-icon-search" @click="searchList">搜索</el-button>
        <el-button icon="el-icon-refresh" class="btn-gray" @click="clearData">重置</el-button>
      </div>
      <div class="add-user" @click="openDrawer">
        <span class="add-rectangle"></span>
        <span>新增</span>
      </div>
    </div>

    <!-- 组长列表 -->
    <div class="table-container">
      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            v-for="(item, index) in tableTitle"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'statusVal'" :class="`status${scope.row.status}`">{{ scope.row.statusVal }}</div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                :disabled="scope.row.status===2"
                class="btn-text"
                type="text"
                @click="updateUser(scope.row)"
              >编辑</el-button>
              <el-button
                class="btn-text"
                type="text"
                @click="updateStatus(scope.row)"
              >
                {{scope.row.status===2?'启用':'禁用'}}
              </el-button>
              <el-button
                v-if="scope.row.status===2"
                class="btn-red-text"
                type="text"
                @click="delHeadman(scope.row.id)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <pagination-tpl
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @queryChange="queryChange"
          ></pagination-tpl>
        </div>
      </div>
    </div>

    <!-- 新增/编辑组长 -->
    <el-drawer
      :title="drawerTitle"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :before-close="handleCloseDrawer">
      <el-form ref="headmanForm" :rules="headmanFormRules" :model="headmanForm">
        <el-form-item label="所属仓库" prop="warehouseId" v-if="drawerTitle === '新增'">
          <el-select class="white" clearable v-model="headmanForm.warehouseId" placeholder="请选择">
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="组长账号" prop="headmanAccount" v-if="drawerTitle === '新增'">
          <el-input v-model="headmanForm.headmanAccount" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="组长姓名" prop="name">
          <el-input v-model="headmanForm.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="headmanForm.phone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="身份证" prop="idCard">
          <el-input v-model="headmanForm.idCard" placeholder="请输入" auto-complete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="headmanForm.password" type="password" placeholder="请输入"  auto-complete="new-password"></el-input>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="submitForm('headmanForm')">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Team from "models/team";
import warehouseMixins from "@/common/mixins/warehouse.js"
import PaginationTpl from "components/base/PaginationTpl";
import { idCardValidity } from "@/common/js/validate";
import { formatTimeToDate } from "common/js/util";
export default {
  mixins: [warehouseMixins],
  components: {
    PaginationTpl,
  },

  data() {
    return {
      form: {
        warehouseId: "",
        username: ""
      },
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitle: [
        {label: '创建日期', prop: 'creatTime', width: ''},
        {label: '仓库名称', prop: 'warehouseName', width: ''},
        {label: '组长名称', prop: 'headmanName', width: ''},
        {label: '组长账号', prop: 'headmanAccount', width: ''},
        {label: '使用状态', prop: 'statusVal', width: ''},
      ],
      drawer: false,
      drawerTitle: '新增',
      headmanForm: {
        id: "",
        warehouseId: null,
        // 组长账号
        headmanAccount: "",
        name: "",
        phone: '',
        idCard: null,
        password: null
      },
      headmanFormRules: {
        warehouseId: [{ required: true, message: "请选择所属仓库", trigger: "change" }],
        headmanAccount: [{ required: true, message: "请输入组长账号", trigger: "blur" }],
        name: [{ required: true, message: "请输入组长姓名", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" }
        ],
        idCard: [
          { required: true, message: "请输入个人身份证号", trigger: "blur" },
          { pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,message: '请输入正确的个人身份证号',trigger: 'blur' },
          { required: true,validator: idCardValidity, trigger: 'blur' },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
    }
  },

  created() {
    this.initWarehouse()
    this.initHeadmanList()
  },

  methods: {
    /** 
     * @desc 组长列表
    */
    initHeadmanList() {
      let warehouseId = this.form.warehouseId
      let leaderName = this.form.username
      let currentPage = this.currentPage
      let data = {
        currentPage,
        warehouseId,
        leaderName
      }
      Team.getHeadmanList(data).then(res => {
        if (res.success) {
          let arr = [];
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          res.result.items.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.creatTime = formatTimeToDate(value.createTime);
            obj.warehouseName = value.warehouseName;
            obj.headmanName = value.leaderName;
            obj.headmanAccount = value.leaderAccount;
            obj.status = value.status;
            obj.statusVal = value.status === 1 ? '已启用': '已禁用';
            arr.push(obj);
          });
          this.tableData = arr;
        }
      });
    },

    /** 
     * @desc 获取详情
    */
    initDetails(id) {
      let data = {
        id
      }
      Team.getHeadmanDetails(data).then(res => {
        if (res.success) {
          let { leaderName, phoneNumber, idNumber } = res.result
          this.headmanForm.name = leaderName;
          this.headmanForm.phone = phoneNumber;
          this.headmanForm.idCard = idNumber;
          this.drawer = true
        } else {
          this.$message.error(res.message)
        }
      });
    },

    searchList() {
      this.currentPage = 1
      this.initHeadmanList()
    },

    clearData() {
      this.form.warehouseId = ""
      this.form.username = ""
    },

    /** 
     * @desc 翻页
    */
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initHeadmanList()
    },

    /**
     * @desc 修改状态
     */
    updateStatus(row) {
      if (row.status == 1) {
        this.$confirm("禁用后，该用户账号将无法登录，请确认", "关闭", {
          confirmButtonText: "关闭",
          cancelButtonText: "取消",
          confirmButtonClass: 'btn-red',
          cancelButtonClass: 'btn-gray'
        }).then(() => {
          this.postUpdateStatus(row.id)
        });
      } else {
        this.$confirm("启用后，该用户账号变更为可登录状态，请确认", "启用", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          confirmButtonClass: 'btn-blue',
          cancelButtonClass: 'btn-gray'
        }).then(() => {
          this.postUpdateStatus(row.id)
        });
      }
    },

    /** 
     * @desc 删除组长
    */
    delHeadman(id) {
      this.$confirm("删除后，该用户账号无法恢复，请确认", "删除", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        let data = {
          id
        };
        Team.postDelHeadmanManage(data).then(res => {
          if (res.success) {
            this.initHeadmanList();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    /**
     * @desc 更新使用状态
     */
    postUpdateStatus(id) {
      let data = {
        id
      };
      Team.postUpdateHeadmanStatus(data).then(res => {
        if (res.success) {
          this.initHeadmanList();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    openDrawer() {
      this.drawerTitle = '新增'
      this.drawer = true
    },

    /**
     * @desc 编辑
     */
    updateUser(row) {
      this.headmanForm.id = row.id;
      this.drawerTitle = '编辑'
      this.initDetails(row.id)
    },
    
    handleCloseDrawer() {
      this.$refs['headmanForm'].resetFields();
      this.headmanForm.name = ''
      this.headmanForm.phone = ''
      this.headmanForm.idCard = null
      this.drawer = false
    },
    
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.headmanForm.id) {
            let data = {};
            data.id = this.headmanForm.id;
            data.phoneNumber = this.headmanForm.phone;
            data.leaderName = this.headmanForm.name;
            data.idNumber = this.headmanForm.idCard;
            data.leaderPassword = this.headmanForm.password;
            Team.postUpdateHeadmanManage(data).then(res => {
              if (res.success) {
                this.initHeadmanList();
                this.handleCloseDrawer();
                this.$message.success("编辑成功");
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let data = {};
            data.warehouseId = this.headmanForm.warehouseId;
            data.leaderAccount = this.headmanForm.headmanAccount;
            data.phoneNumber = this.headmanForm.phone;
            data.leaderName = this.headmanForm.name;
            data.idNumber = this.headmanForm.idCard;
            data.leaderPassword = this.headmanForm.password;
            Team.postAddHeadmanManage(data).then(res => {
              if (res.success) {
                this.initHeadmanList();
                this.handleCloseDrawer();
                this.$message.success("新增成功");
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
  }
}
</script>

<style lang='scss'>
@import "@/assets/style/layout/production/headman-manage.scss";
</style>
